import Highcharts from 'highcharts';

export const figure4 = {
    chart: {
        zoomType: 'xy',
        animation: false,
        marginTop: 50,
        marginLeft: 270,
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
        type: 'bar',
        height: '600px',
        backgroundColor: 'rgba(255, 255, 255, 0.0)',
        style: {
          fontFamily: 'Montserrat'
        }
      },
  
      colors: ['#5b9ad5', '#70ad47', '#ed7d31'],
  
      credits: {
        enabled: false
      },
      title: {
        text: null
      },
      subtitle: {
        text: null
      },
  
      plotOptions: {
        series: {
          borderWidth: 0,
          marker: {
            symbol: 'circle',
            enabled: false,
            states: {
              hover: {
                enabled: true,
                radius: 5
              }
            }
          }
        }
      },
  
      exporting: {
        enabled: false
      },

      xAxis: [{
        reversed: true,
        categories: [
"Mundo",
"África subsahariana",
"Asia central y Asia meridional",
"África septentrional y Asia occidental",
"América Latina y el Caribe",
"Oceanía",
"Asia oriental y Asia sudoriental",
"",
"Países menos adelantados",
"Países en desarrollo sin litoral",
"Pequeños Estados insulares en desarrollo",
         ],
        lineColor: "#d7d7d7",
        tickColor: "#d7d7d7",
        tickLength: 16,
        labels: {
          style: {
            fontWeight: 'normal',
            color: '#999999',
            fontSize: '12px'
          }
        },
      }],
      yAxis: [{
        labels: {
          format: '{value}',
          style: {
            fontWeight: 'normal',
            color: '#999999',
            fontSize: '12px'
          },
        },
        max: 30,
        min: 0,
        tickInterval: 5,
        gridLineWidth: 2,
        title: {
          text: 'Prevalencia de la subalimentación (%)',
          style: {
            color: Highcharts.getOptions().colors[1]
          }
        }
      }],
      tooltip: {
        shared: true,
        useHTML: true,
        hideDelay: 500,
        backgroundColor: null,
        borderWidth: 0,
        shadow: false,
        style: {
          padding: 0
        }
      },
      legend: {
        enabled: false,
      },
  
      series: [      
      {
        name: '2015',
        tooltip: {
          valueSuffix: '%'
        },
        dataLabels: {
          enabled: false,
          style: {
            fontWeight: 'normal',
            textOutline: false,
            color: '#999999',
            fontSize: '12px'
          }
        },
        data: [ 8.3, 19.4, 13.6, 10.5, 5.8, 6.1, 3.3, null, 21.1, 15.9, 14.7 ],
      },

      {
        name: '2019',
        tooltip: {
          valueSuffix: '%'
        },
        dataLabels: {
          enabled: false,
          style: {
            fontWeight: 'normal',
            textOutline: false,
            color: '#999999',
            fontSize: '12px'
          }
        },
        data: [ 8.4, 20.6, 12.9, 10.7, 7.1, 6.2, 2.7, null, 21.5, 16.9, 15.1 ],
      },

      {
        name: '2020*',
        tooltip: {
          valueSuffix: '%'
        },
        dataLabels: {
          enabled: false,
          style: {
            fontWeight: 'normal',
            textOutline: false,
            color: '#999999',
            fontSize: '12px'
          }
        },
        data: [9.9, 24.1, 15.3, 11.3, 9.1, 6.2, 2.9, null, 23.1, 19.1, 15.4],
      },

    
    ]
}